module.exports = __webpack_public_path__ + "static/img/cover2.a8d9f676.jpg";